import React from 'react';
import { useAccessManagement2NModalState } from '../useAccessManagement2NModalState';
import { AccessManagement2NModalContext } from '../index';

/**
 * Provider component for AccessManagement2NModal state management
 * Consolidates all modal state and exposes it via context
 * @component
 * @example
 * // Wrap your modal with the provider
 * <AccessManagement2NModalProvider>
 *   <AccessManagement2NModal />
 * </AccessManagement2NModalProvider>
 */
export const AccessManagement2NModalProvider = ({ children }) => {
  const state = useAccessManagement2NModalState();

  return (
    <AccessManagement2NModalContext.Provider value={state}>
      {children}
    </AccessManagement2NModalContext.Provider>
  );
};
